/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import * as b64$ from "../../lib/base64.js";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SecurityVariable = {
  /**
   * The bearer format
   */
  bearerFormat?: string | undefined;
  /**
   * User-friendly display name for the security variable (defaults to name if not set)
   */
  displayName?: string | undefined;
  /**
   * The environment variables
   */
  envVariables: Array<string>;
  /**
   * The unique identifier of the security variable
   */
  id: string;
  /**
   * Where the security token is placed
   */
  inPlacement: string;
  /**
   * The name of the security scheme (actual header/parameter name)
   */
  name: string;
  /**
   * The OAuth flows
   */
  oauthFlows?: Uint8Array | string | undefined;
  /**
   * The OAuth types
   */
  oauthTypes?: Array<string> | undefined;
  /**
   * The security scheme
   */
  scheme: string;
  /**
   * The type of security
   */
  type?: string | undefined;
};

/** @internal */
export const SecurityVariable$inboundSchema: z.ZodMiniType<
  SecurityVariable,
  unknown
> = z.pipe(
  z.object({
    bearer_format: z.optional(z.string()),
    display_name: z.optional(z.string()),
    env_variables: z.array(z.string()),
    id: z.string(),
    in_placement: z.string(),
    name: z.string(),
    oauth_flows: z.optional(b64$.zodInbound),
    oauth_types: z.optional(z.array(z.string())),
    scheme: z.string(),
    type: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "bearer_format": "bearerFormat",
      "display_name": "displayName",
      "env_variables": "envVariables",
      "in_placement": "inPlacement",
      "oauth_flows": "oauthFlows",
      "oauth_types": "oauthTypes",
    });
  }),
);

export function securityVariableFromJSON(
  jsonString: string,
): SafeParseResult<SecurityVariable, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SecurityVariable$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SecurityVariable' from JSON`,
  );
}
